import { render, staticRenderFns } from "./AddFriend.vue?vue&type=template&id=e993e0b2&scoped=true&lang=html&"
import script from "./AddFriend.vue?vue&type=script&lang=js&"
export * from "./AddFriend.vue?vue&type=script&lang=js&"
import style0 from "./AddFriend.vue?vue&type=style&index=0&id=e993e0b2&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e993e0b2",
  null
  
)

export default component.exports